import { Injectable } from '@angular/core';
import { ToastOptions, toastController } from '@bkkr/core';

import { OverlayBaseController } from '../util/overlay';

@Injectable({
  providedIn: 'root',
})
export class ToastController extends OverlayBaseController<ToastOptions, HTMLBkkrToastElement> {
  constructor() {
    super(toastController);
  }
}
